import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../services/form-field-control.service';
import { FormField } from '../form-field/form-field';
import { FormCanDeactivate } from '../form-field/form-can-deactivate';

@Component({
  standalone: false,
  selector: 'crm-document-modal',
  templateUrl: 'document-modal.template.html',
  providers: [FormFieldControlService],
})
export class CRMDocumentModalComponent extends FormCanDeactivate implements OnInit {
  private privateDisplayDialog: boolean;

  @Input() modalTitle: string;
  @Input() formFields: FormField<string>[] = [];
  @Output() formSubmitEvent = new EventEmitter<FormGroup>();
  @Output() formValueChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() displayDialogChange = new EventEmitter();
  form: FormGroup;

  get displayDialog(): boolean {
    return this.privateDisplayDialog;
  }
  @Input() set displayDialog(value: boolean) {
    this.privateDisplayDialog = value;
    this.displayDialogChange.emit(this.displayDialog);
  }

  constructor(private qcs: FormFieldControlService) {
    super();
  }
  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
    this.form.valueChanges.subscribe((x) => {
      this.formValueChanged.emit(true);
    });
  }
  onSubmit() {
    if (!this.form.valid) {
      return;
    }
    this.formSubmitEvent.emit(this.form);
  }
  onCancel() {
    this.displayDialog = false;
  }
  onUpload(event) {
    // upload functionality goes here
  }
  fileReset(event) {
    // reset the file here
  }
}
